import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = ["onClick"]

import { ref, watchEffect } from 'vue';
import type { District } from '../../../api/types';
import { request } from '../../../api/request';


export default /*@__PURE__*/_defineComponent({
  __name: 'city-panel',
  props: {
    provinceDistrID: {}
  },
  emits: ['select'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emit = __emit
const cityList = ref<District[]>([])
const currentCityId = ref('')

watchEffect(async () => {
  if (!props.provinceDistrID) return

  const data = await request('web.basicBiz.address.getMultiLevelSubList', {
    commonDistrID: props.provinceDistrID
  })
  cityList.value = data.districtList
})

const selectItem = (item) => {
  console.log(item, '市区')
  currentCityId.value = item.districtID
  emit('select', item)
}

__expose({
  reset: () => currentCityId.value = ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['district', item.districtID === currentCityId.value ? 'active' : '']),
        key: item.districtID,
        onClick: ($event: any) => (selectItem(item))
      }, _toDisplayString(item.districtName), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})